import React from 'react';
import clsx from 'clsx';
import { Autocomplete, AutocompleteProps } from '@mui/material';

import AppTextField from '../app-text-field/AppTextField';
import { useStyles } from './AppAutocomplete.styles';
import theme from '../../../styles/theme';

interface IAppAutocompleteProps
  extends AutocompleteProps<any, boolean, boolean, boolean> {
  className?: string;
  placeholder?: string;
}

const AppAutocomplete: React.FC<IAppAutocompleteProps> = ({
  className,
  placeholder,
  disablePortal = true,
  renderInput,
  ...otherProps
}) => {
  const { classes } = useStyles(theme);

  const defaultRenderInput = (params: any) => (
    <AppTextField
      {...params}
      variant="outlined"
      placeholder={placeholder}
      inputProps={{
        ...params.inputProps,
        autoComplete: 'new-password',
      }}
    />
  );

  return (
    <Autocomplete
      className={clsx(classes.appAutocomplete, className)}
      disablePortal={disablePortal}
      renderInput={renderInput || defaultRenderInput}
      {...otherProps}
    />
  );
};

export default AppAutocomplete;
